<template>
  <div class="example-container">
    <button
      class="ec-close-button"
      @click="toggleActionModal(false)"
    >
      <img
        src="@shared/assets/img/general/x-black.png"
        alt="x"
        class="ac-close"
      >
    </button>
    <iframe
      allow="autoplay; fullscreen; picture-in-picture; camera; microphone; display-capture; clipboard-write"
      allowfullscreen=""
      allowtransparency="true"
      referrerpolicy="no-referrer-when-downgrade"
      class="vidyard-iframe-MydcRrdoNxZM87uDVBtp6c"
      frameborder="0"
      height="100%"
      width="100%"
      scrolling="no"
      src="https://www.loom.com/embed/0752f13fce604e4080742b5c2bf21513?sid=7e751f55-be96-462d-80a8-4b503b2a1202"
      title="231012-Virtual Maintenance Visit"
      style="opacity: 1; background-color: transparent; position: absolute; top: 0; left: 0;"
    />
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

export default {
  name: 'ExampleVirtualVisit',
  mixins: [customerDetailMixin],
  data() {
    return {
      exampleHtml: '',
    };
  },
};
</script>

<style lang="scss">

.example-container {
  .ec-close-button {
    position: absolute;
    z-index: 99;
    left: -20px;
    top: -20px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: $NBLUE10;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: $NBLUE20;
    }

    .ac-close {
      width: 15px;
      height: 15px;
    }
  }

  #example-frame {
    width: 100%;
    height: 100%;
  }
}
</style>
